import ApiHandler from "./ApiHandler";

const User = {
  checkProfile: async () => await ApiHandler.i.auth().get('/user/check-profile'),
  findAll: async (query) => await ApiHandler.i.auth().get(`/user/find-all?${query.toString()}`),
  findOne: async (query) => await ApiHandler.i.auth().get(`/user/find-one?${query.toString()}`),
  getJuriesAssigned: async (query) => await ApiHandler.i.auth().get(`/user/jury-assigned?${query.toString()}`),
  getJuriesAvailable: async (query) => await ApiHandler.i.auth().get(`/user/jury-available?${query.toString()}`),
  getOne: async (userId) => await ApiHandler.i.auth().get(`/user/${userId}`),
  getVerify: async (userId) => await ApiHandler.i.auth().get(`/user/${userId}/verify`),
  postJury: async (data, options) => await ApiHandler.i.auth().post('/user/jury', data, options),
  postModerator: async (data, options) => await ApiHandler.i.auth().post('/user/moderator', data, options),
  putJuryBind: async (userId, data, options) => await ApiHandler.i.auth().put(`/user/${userId}/jury-bind`, data, options),
  putJuryUnbind: async (userId, data, options) => await ApiHandler.i.auth().put(`/user/${userId}/jury-unbind`, data, options),
  putModeratorBind: async (userId, data, options) => await ApiHandler.i.auth().put(`/user/${userId}/moderator-bind`, data, options),
  putVerify: async (userId, data, options) => await ApiHandler.i.auth().put(`/user/${userId}/verify`, data, options),
  putVerifyInvited: async () => await ApiHandler.i.auth().put(`/user/verify-invited`, {}),
};

export default User;